import { getAwaitSpinAction } from 'automaton/actions/AwaitSpinAction'
import { getFreeBetSpinState } from 'automaton/states/FreeBetSpinState'
import { getSpinState } from 'automaton/states/SpinState'

import { signal } from '../../services/SignalsService'

export function getFreeBetState() {
  const name = 'FREE-BET'
  const freeBetModel = game.models.FreebetsModel.get()
  signal.dispatch('FREEBET:Enabled', freeBetModel.rest > 0)
  const actions = [getAwaitSpinAction()]
  const transition = () => freeBetModel.rest ? getFreeBetSpinState() : getSpinState()

  return {
    name,
    actions,
    transition,
  }
}
